// src/lib/lottie.ts — the brand Lottie player (BrandLoader, the sign-in intro). lottie-web's SVG-only build is a
// dynamic import, so it never lands in the main chunk; each animation's JSON is fetched and parsed once.
type Lottie = typeof import('lottie-web/build/player/lottie_light').default;
export type LottieAnimation = ReturnType<Lottie['loadAnimation']>;

let lottie: Promise<Lottie> | null = null;
/** The SVG-only Lottie player, loaded once on first use. */
export function loadLottie(): Promise<Lottie> {
  lottie ??= import('lottie-web/build/player/lottie_light').then((m) => m.default);
  return lottie;
}

const animations = new Map<string, Promise<unknown>>();
/** A Lottie JSON from /public, fetched and parsed once per page load. */
export function loadLottieJson(url: string): Promise<unknown> {
  let p = animations.get(url);
  if (!p) {
    p = fetch(url).then((r) => { if (!r.ok) throw new Error(`${url}: ${r.status}`); return r.json() as Promise<unknown>; });
    p.catch(() => animations.delete(url));
    animations.set(url, p);
  }
  return p;
}

export const prefersReducedMotion = () => {
  try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch { return false; }
};
